<template>
  <div>
    <div class="header"></div>
    <div class="news">
      <!-- tab栏 -->
      <div class="tab">
        <ul>
          <li
            v-for="(item, index) in arrowList"
            :key="index"
            :class="{active: tabIndex == index}"
            @click="activeclick(index)"
          >{{item}}</li>
        </ul>
        <div class="crumbs">
          <img src="../../../../static/wy/icon_shouye.png" alt />
          <span @click="$router.push('/home')">首页</span>
          <img src="../../../../static/wy/icon_jiantou.png" alt />
          <span>{{arrow}}</span>
        </div>
      </div>
      <div class="content" v-if="tabContent.length != 0">
        <div class="bar" v-for="(item, index) in tabContent" :key="index">
          <div class="bar-left">
            <div class="bar-date">
              <span>{{item.day}}</span>
              <span>{{item.TitleTime.substring(0,7)}}</span>
            </div>
          </div>
          <div class="bar-right" @click="detailsChange(item.ID)">
            <span>{{item.Title}}</span>
            <div>{{item.Introduction}}</div>
          </div>
        </div>
        <div class="ts" v-if="tabContent.length < 5">------没有更多数据了----</div>
      </div>
      <div id="without" class="con" v-if="tabContent.length == 0">
        ------------暂无数据--------------
      </div>
    </div>
  </div>
</template>

<script>
import { tabMeans } from "../../../api/officialWebsite";
export default {
  data() {
    return {
      arrow: "政策法规",
      arrowList: ["政策法规", "办事指南", "鉴定指南", "技术规范"],
      tabIndex: 0,
      tabContent: [], // tab栏数据
    };
  },
  created() {
    this.journalism(5);
  },
  methods: {
    detailsChange(ID) {
      this.$router.push({
        path: '/particulars',
        query:{
          ID,
          nIndex:3,
          tIndex:this.tabIndex,
        }
      });
    },
    activeclick(index) {
      this.tabIndex = index;
      switch (this.tabIndex) {
        case 0:
          this.arrow = "政策法规";
          this.journalism(5);
          break;
        case 1:
          this.arrow = "办事指南";
          this.journalism(6);
          break;
        case 2:
          this.arrow = "鉴定指南";
          this.journalism(7);
          break;
        case 3:
          this.arrow = "技术规范";
          this.journalism(8);
          break;
        default:
          break;
      }
    },
    journalism(i) {
      tabMeans(i).then((res) => {
        if (res.result == 1) {
          this.tabContent = res.list;
        } else {
          this.$message.error("访问失败");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  width: 1920px;
  height: 400px;
  background: url("../../../../static/wy/banner6.png") no-repeat center center;
  background-size: 100% 100%;
}
.news {
  width: 70%;
  // height: 1051px;
  background: url("../../../../static/wy/bj.png") no-repeat;
  // background-size: 100% 100%;
  margin: 0 auto;
  margin-top: -90px;
  overflow: hidden;
  margin-bottom: 120px;
  // 导航栏
  .tab {
    width: 85%;
    height: 46px;
    // background-color: burlywood;
    margin: 0 auto;
    margin-top: 70px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    ul {
      height: 100%;
      display: flex;
      justify-content: space-between;
      li {
        display: inline-block;
        width: 120px;
        height: 46px;
        font-size: 18px;
        font-weight: 600;
        line-height: 46px;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background-color: #f2f2f2;
        color: red;
        border-bottom: 2px solid red;
        position: relative;
        font-size: 20px;
      }
      .active::after {
        content: "";
        position: absolute;
        left: 46%;
        bottom: -6px;
        border-width: 0 6px 6px;
        border-style: solid;
        border-color: transparent transparent red;
        transform: rotate(180deg);
      }
    }
    .crumbs {
      height: 100%;
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
      img:nth-child(1) {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      img:nth-child(2) {
        width: 8px;
        height: 16px;
      }
      span {
        display: inline-block;
        margin-right: 6px;
        color: #9a9a9a;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
      }
    }
  }
  .content {
    width: 85%;
    height: 600px;
    overflow: scroll;
    margin: 0 auto;
    margin-top: 80px;
    .bar {
      width: 100%;
      height: 120px;
      display: flex;
      margin-top: 14px;
      .bar-left {
        .bar-date {
          margin-top: 20px;
          width: 115px;
          height: 100px;
          background: #f2f2f2;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            display: block;
            background: #f2f2f2;
          }
          span:nth-child(1) {
            font-size: 58px;
            font-weight: 300;
            color: #343434;
          }
          span:nth-child(2) {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #c3c3c3;
          }
        }
      }
      .bar-right {
        margin-left: 20px;
        border-bottom: 1px solid #d0d0d0;
        cursor: pointer;
        span {
          // overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          width: 950px;
          height: 30px;
          font-size: 20px;
          font-weight: bold;
          color: #333333;
          margin-top: 16px;
          margin-bottom: 8px;
        }
        div {
          width: 950px;
          height: 54px;
          line-height: 30px;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          margin: 0 auto;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
    .ts{
      margin-top: 33px;
      text-align: center;
      color:  #999999;
    }
  }
  .con{
    width: 85%;
    height: 400px;
    margin: 0 auto;
    margin-top: 80px;
  }
}
</style>
